<div class="flex flex-col p-6 max-w-5xl mx-auto gap-6">
  <div class="flex flex-col justify-between items-start">
    <p class="flex items-center gap-2 text-xl font-semibold text-[#252B35]">
      <span
        class="material-symbols-rounded text-[#80A363] bg-[#EAF7ED] p-2 rounded-md mr-2"
        >group</span
      >
      {{ "admin.companies.title" | translate }}
    </p>
    <div class="flex items-center gap-4">
      <!-- Search input -->
      <div class="relative w-64 text-sm">
        <input
          #filter
          (input)="onSearchChange(filter.value)"
          [placeholder]="'admin.companies.searchPlaceholder' | translate"
          class="w-full border border-gray-300 rounded-lg py-1.5 pl-3 pr-10"
          type="text"
        />
        <span
          class="material-symbols-rounded text-gray-500 absolute right-2 top-1/2 -translate-y-1/2 text-base"
          >search</span
        >
      </div>
      <div class="flex items-center gap-2">
        <button
          (click)="downloadCompaniesBillingCsv()"
          class="flex items-center gap-2 border text-[#6A7381] border-[#6A7381] rounded-md px-2 text-sm"
        >
          <p class="!m-0">{{ "admin.companies.downloadCsv" | translate }}</p>
          <span class="material-symbols-rounded text-[#5b774a] scale-90">
            download
          </span>
        </button>
      </div>
    </div>
  </div>

  @if (companies$ | async; as paginatedCompanies) {
    <div class="flex flex-col">
      @for (company of paginatedCompanies.items; track company.id) {
        <div (click)="goToDetails(company.id)">
          <app-company-card [company]="company" />
        </div>
      }
    </div>

    <div class="self-center mt-6">
      <app-pagination
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        [currentPage]="paginatedCompanies.page"
        [totalPages]="paginatedCompanies.totalPages"
      />
    </div>
  }
</div>
